





















































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Action, Getter } from 'vuex-class';
import { Babysitter } from '@/interfaces/Models';

@Component
export default class BabysitterOverview extends Vue {
    public data: any = null;
    public loading: boolean = false;
    public babysitterName = null
    public babysitterLoading: boolean  = false;
    public babysitters: any[] = [];
    public babysitter: any = null;
    public babysitterRules: ( (v: any) => void )[] = [
        (v: Babysitter) => !!v || 'Babysitter is required',
    ];

    public yearAndMonthMenu: boolean = false;

    public $refs!: {
        form: HTMLFormElement
    }

    @Watch('babysitterName')
    @Debounce(500)
    onBabysitterNameChange( value: string ): void {

        let params = {
            paginate: 'no',
            babysitter: value
        }
        this.babysitterLoading = true;

        if ( value === null ) {
            this.babysitterLoading = false;
            this.babysitters = [];
            return;
        }
        
        axios.get(api.path('v1.admin.babysitters'), { params: params })
            .then( res => {
                this.babysitterLoading = false;
                this.babysitters = res.data.data;
            });
    }

    @Action('transactions/setDate') setDate: any;
    @Getter('transactions/date') dateState: any;
    public get date(): string {
        return this.dateState;
    }

    public set date(date: string) {
        this.setDate(date);
    }

    public async fetchBabysitterStatistics() {
        
        this.loading = true;
        axios.get(api.path('v1.admin.statistics.babysitters'), { 
            params: { 
                date: this.date, 
                id: this.babysitter?.id ?? null  
            } 
        })
            .then( res => this.data = res.data.data )
            .finally( () => this.loading = false );
    }
}
